import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
var HeaderCFTemplate = function (_a) {
    var title = _a.title, listBtns = _a.listBtns;
    return (_jsxs("div", { className: 'flex justify-between items-center', children: [_jsx(Typography, { variant: 'h3', children: title }), _jsx("div", { className: 'flex items-center gap-2', children: listBtns.map(function (btn, index) { return (_jsx("div", { children: btn }, "btns_".concat(index))); }) })] }));
};
export default HeaderCFTemplate;
